// `extension-whitelabel-department.api.ng1.ts` — the whitelabel's departments, as they apply
// to the signed-in extension user.
import { request } from './request.ts'

const DEPARTMENTS = '/chrome-extension-api/whitelabel-department'

/** `IExtensionUserInWhitelabelDepartmentDto`. */
export interface UserDepartment {
  userId: number
  departmentId: number
  departmentName: string
  /** Whether THIS user is assigned to it — the row exists either way. */
  inDepartment: boolean
}

/**
 * ⚠️ `1` IS "None of the above" AND IS NOT A DEPARTMENT. Upstream hard-codes it as
 * `ExtensionWhitelabelDepartmentApi.NoneOfTheAboveDepartmentId` and filters it out of every
 * chooser. Measured on the dev tenant, it is the ONLY row returned — so a port that forgets
 * the filter renders a department dropdown whose single option is "None of the above",
 * which looks like real data and is not.
 */
export const NONE_OF_THE_ABOVE_DEPARTMENT_ID = 1

export async function getUserDepartments(): Promise<UserDepartment[]> {
  return request('GET', `${DEPARTMENTS}/getExtensionUserDepartmentAssignmentsByUserId`)
}

/** `removeNoneOfTheAboveDepartment` — by id, not by name. */
export function withoutNoneOfTheAbove(departments: readonly UserDepartment[]): UserDepartment[] {
  return departments.filter((department) => department.departmentId !== NONE_OF_THE_ABOVE_DEPARTMENT_ID)
}

/**
 * `updateExtensionUserDepartments(selectedIds)` — POST, a bare JSON ARRAY of department ids as the
 * body, answering the user's assignments as they now stand. ⚠️ A WRITE to the user's account:
 * it replaces their department membership, which is what scopes their searches by department.
 */
export async function updateUserDepartments(departmentIds: readonly number[]): Promise<UserDepartment[]> {
  return request('POST', `${DEPARTMENTS}/updateExtensionUserDepartments`, departmentIds)
}
